import React, { useContext } from "react";

import {
  IonSlides,
  IonSlide,
  IonContent,
  IonButton,
  IonPage,
} from "@ionic/react";

import { Link } from "react-router-dom";

import { createUseStyles } from "react-jss";

import SmartphoneIcon from "../../assets/pages/smartphone.svg";
import BusIcon from "../../assets/pages/bus.svg";
import { AppContext } from "../../base/AppContext";

import "./style.css";

const useStyles = createUseStyles({
  text: {
    padding: "0 40px",
    fontSize: 14,
    lineHeight: "1.5",
    color: "var(--ion-color-step-600, #60646b)",
    "& b": {
      color: "var(--ion-text-color, #000000)",
    },
  },
  pageWelcome: {
    "& b": {
      fontWeight: 500,
    },
  },
});

export const WelcomePage: React.FC = () => {
  const options = {
    initialSlide: 0,
    speed: 400,
  };

  const classes = useStyles();

  const { setWelcome } = useContext(AppContext);

  return (
    <IonPage>
      <IonContent className={`welcome-page ${classes.pageWelcome}`}>
        <IonSlides pager={true} options={options}>
          <IonSlide>
            <div className="slide">
              <div className="content">
                <img src={SmartphoneIcon} alt="Apresentação Smartphone" />
                <h2>Bem-vindo!</h2>
                <p className={classes.text}>
                  O <b>App PassageVan</b> foi criado para auxiliar os usuários
                  nas marcações das passagens. Sem os transtornos de ficar
                  falando com o motorista da van! Em parceria com{" "}
                  <b>Adriano Transportes</b>
                </p>
              </div>
            </div>
          </IonSlide>
          <IonSlide>
            <div className="slide">
              <div className="content">
                <img
                  src={BusIcon}
                  style={{ maxWidth: "76%" }}
                  alt="Apresentação Smartphone"
                />
                <h2>Vamos marca sua passagem?</h2>
                <p className={classes.text}>
                  The <b>ionic conference app</b> is a practical preview of the
                  ionic framework in action, and a demonstration of proper code
                  use.
                </p>
              </div>
              <div className="footer">
                <Link to="/page/passages" onClick={setWelcome}>
                  <IonButton>Próximo</IonButton>
                </Link>
              </div>
            </div>
          </IonSlide>
        </IonSlides>
      </IonContent>
    </IonPage>
  );
};
